import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export function ScrollReset() {
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);
  return (<></>);
}
export function FooterLink({src, to}){
    return(
        <Link to = {to} target = "_blank" className = "footerLink">
            <img src = {src} alt = "FIX"></img>
        </Link>
    )
}

export function Window({children, title}){
    return(
        <table className = "window">
            <tbody>
                <tr>
                    <th>
                        <span>
                        <p>{title}</p>
                        <p>-◻x</p>
                        </span>
                    </th>
                </tr>

                <tr>
                    <td>{children}</td>
                </tr>
            </tbody>
        </table>

    )

}

export function Quicklink({src, children, path}){
    return (
        <Link to = {path} className = "quicklink" target = "_blank">
            <img src = {src} alt = "FIX"></img>
            <p>{children}</p>
        </Link>
    )
}



export function Prompt({children, text = 'Learn more >>'}){
    return (
        <div className = "prompt">
            <p>
                {children}
            </p>
            {/* <button className = "promptButton menuButton">
                {text}
            </button> */}
        </div>

    )
}


export function PicLink({target, src}){
    return (<Link to= {target} className = "piclink">
        <img src = {src} alt = "FIX">
        
        </img>
    </Link>)
}

export function Eventwindow({title, children, src, href}){
    const tit = `\\* ${title} *\\`;
    return (<a href = {href} className = "eventwindow piclink">
        <Window title = {tit}>
            <img src = {src} className = "piclink" alt = "FIX"></img>
            <p>{children}</p>
        </Window>
    </a>)
}

export function EventLink({title, children, to, local = true}){
    const ext = local ? `/events/${to}`: `/${to}`;
    return (<Link to = {ext} className = "eventlink" target = {local ? "_self" : "_blank"}>
        <h4 className ="prevent-select">{title}</h4>
        <p>{children}</p>
    </Link>)
}

export function EventBanner({children}){
    return(<section className = "eventBanner">
        
        <Link to = "/events" className = "promptButton menuButton">&lt;&lt; Events</Link>
        <h3>{children}</h3>
    </section>)
}

export function EventResources({title = "RESOURCES", children}){
    return(<div className = "eventresources">
        <h3>{title}</h3>
        <div>{children}</div>
    </div>)
}